import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import OwnerSidebar from './OwnerSidebar';
import OwnerHeader  from './OwnerHeader';

const css = `
  .ow-shell { display:flex; height:100vh; background:#f0f2f7; overflow:hidden; }
  .ow-main  { flex:1; display:flex; flex-direction:column; min-width:0; overflow:hidden; }
  .ow-body  { flex:1; overflow-y:auto; overflow-x:hidden; padding:28px 32px; }
  .ow-overlay { display:none; position:fixed; inset:0; background:rgba(0,0,0,.45); z-index:40; }
  @media (max-width:768px) {
    .ow-body { padding:16px; }
    .ow-overlay.open { display:block; }
  }
`;

export default function OwnerLayout() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <style>{css}</style>
      <div className="ow-shell">
        <OwnerSidebar open={open} onClose={() => setOpen(false)} />
        <div className={`ow-overlay${open?' open':''}`} onClick={() => setOpen(false)} />
        <div className="ow-main">
          <OwnerHeader onMenuClick={() => setOpen(true)} />
          <div className="ow-body"><Outlet /></div>
        </div>
      </div>
    </>
  );
}